import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Facebook, Meet, Slack, Whatsapp, Youtube } from "../IconTheme";

const social_icons = [
	{
		icon: <Facebook />,
		link: "#",
	},
	{
		icon: <Slack />,
		link: "#",
	},
	{
		icon: <Youtube />,
		link: "#",
	},
	{
		icon: <Meet />,
		link: "#",
	},
	{
		icon: <Whatsapp />,
		link: "#",
	},
];

const SocialIcons = ({ data, className }) => {
	const [social, setSocial] = useState(data || social_icons);
	return (
		<>
			<ul className={`social-icons ${className ? className : ""}`}>
				{social.map(({ icon, link }, i) => (
					<li key={i}>
						<Link to={link}>{icon}</Link>
					</li>
				))}
			</ul>
		</>
	);
};

export default SocialIcons;
